import React from "react";
import FirebaseContext from "./firebase";

const SettingsContext = React.createContext();

const SettingsProvider = ({ children }) => {
  const [data, setData] = React.useState(null);

  const firebaseContext = React.useContext(FirebaseContext);

  const { db } = firebaseContext;

  const fetch = React.useCallback(() => {
    db.collection("settings")
      .doc("default")
      .get()
      .then((snapshot) => {
        if (snapshot.exists) {
          setData(snapshot.data());
        }
      });
  }, [db]);

  React.useEffect(() => {
    if (data === null) fetch();
  }, [data, fetch]);

  const value = {
    data,
  };

  return (
    <SettingsContext.Provider value={value}>
      {children}
    </SettingsContext.Provider>
  );
};

export default SettingsContext;

export { SettingsProvider };
